/* Каса й фіноперації (/cash, batch B12). Kept apart from uk.ts/en.ts to keep merges small. */
export const cashopsUk = {
  'nav.cash': 'Каса й фіноперації',
  'perm.cash.desk': 'Каса: зміни, Z-звіти, нічні оплати, графік кас',
  'perm.cash.night_record': 'Записати нічну оплату',
  'perm.cash.discount_request': 'Заявка на знижку',
  'perm.cash.manage': 'Графік кас, довідник кас, погодження знижок',
  'perm.cash.finance': 'Ліміти ФОП, контроль місяця (ЗП), позики',
  'cash.title': 'Каса й фіноперації',
  'cash.subtitle': 'Каса дня за графіком ротації ФОП, зміни із Z-звітами, нічні оплати, знижки, ліміти ФОП, контроль місяця і позики. Гроші бачать лише фінансові ролі.',
  'cash.seed': 'Додати типові налаштування',
  'cash.seeded': 'Норми, категорії знижок і чеклісти додано',
  'cash.tab.today': 'Сьогодні',
  'cash.tab.rotation': 'Графік кас',
  'cash.tab.check': 'Звірка кас',
  'cash.tab.shifts': 'Зміни й Z-звіти',
  'cash.tab.night': 'Нічні оплати',
  'cash.tab.discounts': 'Знижки',
  'cash.tab.limits': 'Ліміти ФОП',
  'cash.tab.payroll': 'Контроль місяця',
  'cash.tab.loans': 'Позики',
  'cash.slot': 'Каса',
  'cash.slot.day': 'Денна',
  'cash.slot.evening': 'Вечірня/нічна',
  'cash.slot.pet_shop': 'Зоотовари',
  'cash.shiftStatus.open': 'Відкрита',
  'cash.shiftStatus.closed': 'Закрита',
  'cash.shiftStatus.discrepancy': 'Розбіжність',
  'cash.shiftStatus.reviewed': 'Перевірено',
  'cash.shiftStatus.cancelled': 'Скасована',
  'cash.nightStatus.recorded': 'Чекає проведення',
  'cash.nightStatus.posted': 'Проведено',
  'cash.nightStatus.cancelled': 'Скасовано',
  'cash.method.card': 'Картка',
  'cash.method.cash': 'Готівка',
  'cash.method.transfer': 'Переказ',
  'cash.method.salary': 'З зарплати',
  'cash.method.other': 'Інше',
  'cash.discountStatus.requested': 'Очікує погодження',
  'cash.discountStatus.approved': 'Погоджено',
  'cash.discountStatus.rejected': 'Відхилено',
  'cash.discountStatus.applied': 'Застосовано в Enote',
  'cash.discountStatus.cancelled': 'Відкликано',
  'cash.loanStatus.open': 'Відкриті',
  'cash.loanStatus.repaid': 'Погашені',
  'cash.loanStatus.written_off': 'Списані',
  'cash.level.ok': 'У межах',
  'cash.level.warn': 'Попередження',
  'cash.level.high': 'Близько до ліміту',
  'cash.level.over': 'Ліміт досягнуто',
  'cash.level.no_limit': 'Ліміт не задано',
  'cash.mismatch.wrong_fop': 'Не той ФОП',
  'cash.mismatch.unattributed': 'Рахунок без ФОП',
  'cash.mismatch.no_rotation': 'Немає в графіку',
  'cash.kind': 'Що',
  'cash.kind.prro': 'ПРРО / Checkbox',
  'cash.kind.terminal': 'Термінал',
  'cash.kind.other': 'Інше',
  'cash.uah': 'грн',
  'cash.nowRegister': 'Зараз — каса «{slot}»',
  'cash.noRotationToday': 'На сьогодні графік кас не заповнено',
  'cash.noRotationTodayHint': 'Керуюча або фінансист заповнює графік на вкладці «Графік кас». Без нього оберіть ФОП при відкритті зміни.',
  'cash.slotHint': 'Денна каса з {day}, вечірня/нічна — з {evening} (норма «cash_slot_hours»).',
  'cash.stat.night': 'Нічні оплати до проведення',
  'cash.stat.discounts': 'Погоджені знижки до застосування',
  'cash.stat.mismatches': 'Оплати не на касу дня (вчора)',
  'cash.openShifts': 'Відкриті зміни',
  'cash.noOpenShifts': 'Відкритих змін немає',
  'cash.noOpenShiftsHint': 'На початку зміни натисніть «Відкрити зміну» — Bridge візьме ФОП із графіка і відкриє чекліст відкриття каси.',
  'cash.openShift': 'Відкрити зміну',
  'cash.openShiftHint': 'ФОП береться з графіка кас. Якщо обрати інший, керівнику прийде сповіщення.',
  'cash.currentSlot': 'Поточна',
  'cash.byRotation': 'За графіком',
  'cash.fopByRotation': 'Термінал і ПРРО мають бути відкриті на тому самому ФОП.',
  'cash.opened': 'Відкрито',
  'cash.openedOffRotation': 'Зміну відкрито не на ФОП з графіка — керівника сповіщено',
  'cash.closeShift': 'Закрити зміну',
  'cash.closeShiftN': 'Закрити зміну №{n} — {fop}',
  'cash.closeHint': 'Внесіть підсумки Z-звіту (сума продажів мінус повернення). Фото Z-звітів завантажте в чекліст закриття каси.',
  'cash.closed': 'Зміну закрито, Z-звіт збігається з Enote',
  'cash.closedDiscrepancy': 'Зміну закрито: Z-звіт не збігається з Enote — керівника сповіщено',
  'cash.zCash': 'Z-звіт: готівка, грн',
  'cash.zCard': 'Z-звіт: картка, грн',
  'cash.zReturns': 'Повернення, грн',
  'cash.zNumber': 'Номер Z-звіту',
  'cash.enoteShift': 'Касова зміна Enote',
  'cash.enoteShiftHint': 'Порожньо — Bridge знайде зміну за оплатами цього ФОП від відкриття.',
  'cash.shiftN': 'Зміна №{n}',
  'cash.cancelShift': 'Скасувати зміну',
  'cash.linkEnote': 'Привʼязати зміну Enote',
  'cash.review': 'Розбіжність пояснено',
  'cash.reviewNote': 'Пояснення розбіжності',
  'cash.openRun': 'Чекліст відкриття',
  'cash.closeRun': 'Чекліст закриття',
  'cash.openChecklist': 'Відкрити чекліст',
  'cash.closeChecklist': 'Чекліст і фото Z-звітів',
  'cash.offRotation': 'Не за графіком (мав бути {fop})',
  'cash.tooLong': 'Не закрита вчасно',
  'cash.z': 'Z-звіт (готівка / картка)',
  'cash.enote': 'Enote (готівка / картка)',
  'cash.difference': 'Різниця',
  'cash.noShifts': 'Змін за період немає',
  'cash.noShiftsHint': 'Зміни зʼявляються, коли адміністратор відкриває касу. Змініть період або відкрийте зміну.',
  'cash.from': 'З',
  'cash.to': 'По',
  'cash.date': 'Дата',
  'cash.prevMonth': 'Попередній місяць',
  'cash.nextMonth': 'Наступний місяць',
  'cash.branchShared': 'Спільний (обидві філії)',
  'cash.fill': 'Заповнити ротацію',
  'cash.fillHint': 'Оберіть ФОП у порядку черги: кожен наступний день отримує наступного ФОП.',
  'cash.fillOrder': 'ФОП у порядку черги',
  'cash.filled': 'Заповнено днів: {n}',
  'cash.overwrite': 'Перезаписати вже заповнені дні',
  'cash.rotationRisk': 'Bridge лише показує графік і обороти. Ротація кас між ФОП може розцінюватися як ознака дроблення бізнесу — юридичне рішення залишається за власником.',
  'cash.noFops': 'ФОП ще не додано',
  'cash.noFopsHint': 'Додайте ФОП у «Адміністрування → ФОПи» і привʼяжіть до них грошові рахунки Enote.',
  'cash.summary': 'Кількість змін на ФОП за місяць',
  'cash.fop': 'ФОП',
  'cash.registers': 'Довідник кас',
  'cash.registersHint': 'Лише назви і серійні номери. Логіни, паролі й ключі Checkbox у Bridge не зберігаються.',
  'cash.addRegister': 'Додати касу',
  'cash.noRegisters': 'Кас ще не додано',
  'cash.noRegistersHint': 'Додайте ПРРО і термінали кожного ФОП, щоб бачити їх у графіку.',
  'cash.registerName': 'Назва',
  'cash.registerKind': 'Тип',
  'cash.serial': 'Серійний / фіскальний номер',
  'cash.noSecrets': 'Не вводьте логіни, паролі чи ключі — вони зберігаються лише в менеджері паролів.',
  'cash.notes': 'Примітки',
  'cash.active': 'Активна',
  'cash.saved': 'Збережено',
  'cash.checkHint': 'Порівнює ФОП, на який пройшла кожна фіскальна оплата (за грошовим рахунком Enote), з графіком кас для її зміни. Філії обʼєднано: оплати в Enote не мають філії.',
  'cash.checked': 'Перевірено оплат',
  'cash.byDay': 'По днях',
  'cash.planned': 'За графіком',
  'cash.actual': 'Фактично (оплат)',
  'cash.mismatchedPayments': 'Оплати не на касу дня',
  'cash.noMismatches': 'Усі оплати пройшли на каси з графіка',
  'cash.noMismatchesHint': 'Розбіжностей за цей період немає.',
  'cash.paidAt': 'Оплата',
  'cash.actualFop': 'Фактичний ФОП',
  'cash.expected': 'Мав бути',
  'cash.amount': 'Сума',
  'cash.status': 'Статус',
  'cash.nightHint': 'Лікар записує оплату, прийняту вночі, з телефона (або команда /night у боті). Вранці адміністратор проводить її в ПРРО та Enote і позначає «Проведено».',
  'cash.recordNight': 'Записати нічну оплату',
  'cash.recordNightHint': 'Сума, спосіб оплати і хто платив — як у паперовому бланку.',
  'cash.record': 'Записати',
  'cash.nightRecorded': 'Нічну оплату записано',
  'cash.noNight': 'Нічних оплат немає',
  'cash.noNightHint': 'Коли вночі приймаєте оплату, запишіть її тут або в боті командою /night.',
  'cash.takenBy': 'Прийняв(ла): {name}',
  'cash.postedAs': 'Проведено як оплата №{number} ({by})',
  'cash.posted': 'Проведено',
  'cash.suggested': 'Схожі оплати в Enote:',
  'cash.cancelNight': 'Скасувати запис',
  'cash.reason': 'Причина',
  'cash.method': 'Спосіб',
  'cash.owner': 'Власник',
  'cash.pet': 'Тварина',
  'cash.forWhat': 'За що',
  'cash.fromPaper': 'Переношу з паперового бланка',
  'cash.month': 'Місяць',
  'cash.requestDiscount': 'Заявка на знижку',
  'cash.noDiscounts': 'Заявок на знижку немає',
  'cash.noDiscountsHint': 'Лікар або адміністратор створює заявку: категорія, візит, підстава. Сума рахується за правилом категорії.',
  'cash.category': 'Категорія',
  'cash.who': 'Клієнт',
  'cash.staffFlag': 'Співробітник',
  'cash.visitN': 'Візит {n}',
  'cash.requestedBy': 'Заявка: {name}',
  'cash.approve': 'Погодити',
  'cash.reject': 'Відхилити',
  'cash.applied': 'Застосовано в Enote',
  'cash.withdraw': 'Відкликати',
  'cash.discountReport': 'Знижки за місяць по категоріях',
  'cash.requests': 'Заявок',
  'cash.approvedN': 'Погоджено',
  'cash.total': 'Разом',
  'cash.evidenceCheck': 'Перевірити: {what}',
  'cash.staffRule': 'Знижка співробітнику погоджується фінансами і позначається окремо.',
  'cash.visitId': 'Візит Enote (id)',
  'cash.visitIdHint': 'Клієнт, тварина і повна вартість підтягнуться з візиту.',
  'cash.employee': 'Співробітник',
  'cash.basePrice': 'Повна вартість, грн',
  'cash.basePriceHint': 'Порожньо — сума візиту.',
  'cash.percent': 'Відсоток',
  'cash.fixedAmount': 'Або фіксована сума, грн',
  'cash.evidence': 'Що перевірено',
  'cash.evidenceHint': 'Напр. «посвідчення УБД перевірено». Номери документів не записуйте.',
  'cash.discountPreview': 'Знижка: {sum}',
  'cash.discountSent': 'Заявку надіслано на погодження',
  'cash.send': 'Надіслати',
  'cash.limitsHint': 'Оборот кожного ФОП за рік (оплати за грошовими рахунками Enote, мінус повернення, без бонусів) проти ліміту єдиного податку, з прогнозом на кінець року. Рішення про розподіл оборотів — за власником.',
  'cash.year': 'Рік',
  'cash.limitsToConfirm': 'Ліміти груп потребують підтвердження (норма fop_income_limits)',
  'cash.unattributed': 'Оплати без ФОП: {sum}',
  'cash.net': 'Оборот',
  'cash.limit': 'Ліміт',
  'cash.limitOwn': 'власний',
  'cash.limitGroup': 'за групою',
  'cash.limitNone': 'не задано',
  'cash.share': 'Використано',
  'cash.forecast': 'Прогноз на рік',
  'cash.group': '{g} група',
  'cash.noGroup': 'група не вказана',
  'cash.setLimit': 'Ліміт',
  'cash.setLimitFor': 'Ліміт: {fop}',
  'cash.limitEmptyHint': 'Порожньо — ліміт за групою єдиного податку.',
  'cash.payrollHint': 'Щомісячний чекліст по зарплатному файлу: борги й аванси тварин співробітників, неперераховані чеки, знижки співробітникам, закриття боргів із ЗП, погашення позик. Суми зарплат у Bridge не зберігаються.',
  'cash.startPayroll': 'Почати контроль місяця',
  'cash.payrollStarted': 'Чекліст контролю місяця створено',
  'cash.noPayroll': 'Контролів місяця ще не було',
  'cash.noPayrollHint': 'Оберіть місяць і натисніть «Почати контроль місяця».',
  'cash.progress': 'Виконано',
  'cash.due': 'Строк',
  'cash.payrollDone': 'Виконано',
  'cash.payrollOpen': 'У роботі',
  'cash.overdue': 'Прострочено',
  'cash.addLoan': 'Нова позика',
  'cash.noLoans': 'Позик немає',
  'cash.noLoansHint': 'Внесіть позику співробітнику чи іншій стороні: сума, валюта, курс, строк і план погашення.',
  'cash.counterparty': 'Кому / від кого',
  'cash.balance': 'Залишок',
  'cash.loanIssued': 'Видано клінікою',
  'cash.loanReceived': 'Отримано клінікою',
  'cash.repaymentsN': 'Погашень: {n}',
  'cash.repay': 'Погашення',
  'cash.writeOff': 'Списати',
  'cash.loanN': 'Позика №{n}',
  'cash.direction': 'Напрям',
  'cash.currency': 'Валюта',
  'cash.rate': 'Курс до гривні',
  'cash.issuedOn': 'Видано',
  'cash.schedule': 'План погашення',
  'cash.repayLoan': 'Погашення позики №{n}',
  'cash.balanceIs': 'Залишок: {sum}',
  'cash.paidOn': 'Дата',
}

export const cashopsEn: { [K in keyof typeof cashopsUk]?: string } = {
  'nav.cash': 'Cash desk & finance',
  'perm.cash.desk': 'Cash desk: shifts, Z-reports, night payments, register rotation',
  'perm.cash.night_record': 'Record a night payment',
  'perm.cash.discount_request': 'Request a discount',
  'perm.cash.manage': 'Register rotation and directory, discount approval',
  'perm.cash.finance': 'ФОП limits, month-end payroll control, loans',
  'cash.title': 'Cash desk & finance',
  'cash.subtitle': 'Today’s ФОП register by the rotation, shifts with Z-reports, night payments, discounts, ФОП limits, month-end control and loans. Money is visible to finance roles only.',
  'cash.seed': 'Add default settings',
  'cash.seeded': 'Norms, discount categories and checklists added',
  'cash.tab.today': 'Today',
  'cash.tab.rotation': 'Register rotation',
  'cash.tab.check': 'Register check',
  'cash.tab.shifts': 'Shifts & Z-reports',
  'cash.tab.night': 'Night payments',
  'cash.tab.discounts': 'Discounts',
  'cash.tab.limits': 'ФОП limits',
  'cash.tab.payroll': 'Month-end control',
  'cash.tab.loans': 'Loans',
  'cash.slot': 'Register',
  'cash.slot.day': 'Day',
  'cash.slot.evening': 'Evening/night',
  'cash.slot.pet_shop': 'Pet shop',
  'cash.shiftStatus.open': 'Open',
  'cash.shiftStatus.closed': 'Closed',
  'cash.shiftStatus.discrepancy': 'Discrepancy',
  'cash.shiftStatus.reviewed': 'Reviewed',
  'cash.shiftStatus.cancelled': 'Cancelled',
  'cash.nightStatus.recorded': 'To post',
  'cash.nightStatus.posted': 'Posted',
  'cash.nightStatus.cancelled': 'Cancelled',
  'cash.method.card': 'Card',
  'cash.method.cash': 'Cash',
  'cash.method.transfer': 'Transfer',
  'cash.method.salary': 'From salary',
  'cash.method.other': 'Other',
  'cash.discountStatus.requested': 'Awaiting approval',
  'cash.discountStatus.approved': 'Approved',
  'cash.discountStatus.rejected': 'Rejected',
  'cash.discountStatus.applied': 'Applied in Enote',
  'cash.discountStatus.cancelled': 'Withdrawn',
  'cash.loanStatus.open': 'Open',
  'cash.loanStatus.repaid': 'Repaid',
  'cash.loanStatus.written_off': 'Written off',
  'cash.level.ok': 'Within limit',
  'cash.level.warn': 'Warning',
  'cash.level.high': 'Close to limit',
  'cash.level.over': 'Limit reached',
  'cash.level.no_limit': 'No limit set',
  'cash.mismatch.wrong_fop': 'Wrong ФОП',
  'cash.mismatch.unattributed': 'Account without ФОП',
  'cash.mismatch.no_rotation': 'Not in the rotation',
  'cash.kind': 'What',
  'cash.kind.prro': 'Fiscal register / Checkbox',
  'cash.kind.terminal': 'Terminal',
  'cash.kind.other': 'Other',
  'cash.uah': 'UAH',
  'cash.nowRegister': 'Now — «{slot}» register',
  'cash.noRotationToday': 'No register rotation for today',
  'cash.noRotationTodayHint': 'The manager or finance fills the rotation on the «Register rotation» tab. Without it, choose the ФОП when opening a shift.',
  'cash.slotHint': 'Day register from {day}, evening/night from {evening} (norm «cash_slot_hours»).',
  'cash.stat.night': 'Night payments to post',
  'cash.stat.discounts': 'Approved discounts to apply',
  'cash.stat.mismatches': 'Payments not on the day’s register (yesterday)',
  'cash.openShifts': 'Open shifts',
  'cash.noOpenShifts': 'No open shifts',
  'cash.noOpenShiftsHint': 'At the start of the shift press «Open shift» — Bridge takes the ФОП from the rotation and opens the cash-open checklist.',
  'cash.openShift': 'Open shift',
  'cash.openShiftHint': 'The ФОП comes from the rotation. Choosing another one notifies the manager.',
  'cash.currentSlot': 'Current',
  'cash.byRotation': 'By the rotation',
  'cash.fopByRotation': 'The terminal and the fiscal register must be open on the same ФОП.',
  'cash.opened': 'Opened',
  'cash.openedOffRotation': 'Shift opened on a ФОП other than the rotation’s — the manager was notified',
  'cash.closeShift': 'Close shift',
  'cash.closeShiftN': 'Close shift #{n} — {fop}',
  'cash.closeHint': 'Enter the Z-report totals (sales minus returns). Upload the Z-report photos to the cash-close checklist.',
  'cash.closed': 'Shift closed, the Z-report matches Enote',
  'cash.closedDiscrepancy': 'Shift closed: the Z-report differs from Enote — the manager was notified',
  'cash.zCash': 'Z-report: cash, UAH',
  'cash.zCard': 'Z-report: card, UAH',
  'cash.zReturns': 'Returns, UAH',
  'cash.zNumber': 'Z-report number',
  'cash.enoteShift': 'Enote cash shift',
  'cash.enoteShiftHint': 'Empty — Bridge finds it from this ФОП’s payments since opening.',
  'cash.shiftN': 'Shift #{n}',
  'cash.cancelShift': 'Cancel shift',
  'cash.linkEnote': 'Link Enote shift',
  'cash.review': 'Difference explained',
  'cash.reviewNote': 'Explanation',
  'cash.openRun': 'Open checklist',
  'cash.closeRun': 'Close checklist',
  'cash.openChecklist': 'Open the checklist',
  'cash.closeChecklist': 'Checklist and Z-report photos',
  'cash.offRotation': 'Off rotation (should be {fop})',
  'cash.tooLong': 'Not closed in time',
  'cash.z': 'Z-report (cash / card)',
  'cash.enote': 'Enote (cash / card)',
  'cash.difference': 'Difference',
  'cash.noShifts': 'No shifts in the period',
  'cash.noShiftsHint': 'Shifts appear when the desk opens the register. Change the period or open a shift.',
  'cash.from': 'From',
  'cash.to': 'To',
  'cash.date': 'Date',
  'cash.prevMonth': 'Previous month',
  'cash.nextMonth': 'Next month',
  'cash.branchShared': 'Shared (both branches)',
  'cash.fill': 'Fill the rotation',
  'cash.fillHint': 'Choose ФОПи in queue order: each next day gets the next ФОП.',
  'cash.fillOrder': 'ФОПи in queue order',
  'cash.filled': 'Days filled: {n}',
  'cash.overwrite': 'Overwrite days already set',
  'cash.rotationRisk': 'Bridge only shows the rotation and turnover. Rotating registers between ФОПи may be seen as splitting the business — the legal decision stays with the owner.',
  'cash.noFops': 'No ФОПи yet',
  'cash.noFopsHint': 'Add ФОПи in «Admin → ФОПи» and map the Enote money accounts to them.',
  'cash.summary': 'Shifts per ФОП this month',
  'cash.fop': 'ФОП',
  'cash.registers': 'Registers',
  'cash.registersHint': 'Names and serial numbers only. Checkbox logins, passwords and keys are never stored in Bridge.',
  'cash.addRegister': 'Add register',
  'cash.noRegisters': 'No registers yet',
  'cash.noRegistersHint': 'Add the fiscal registers and terminals of every ФОП to see them in the rotation.',
  'cash.registerName': 'Name',
  'cash.registerKind': 'Type',
  'cash.serial': 'Serial / fiscal number',
  'cash.noSecrets': 'Do not enter logins, passwords or keys — keep them in the password manager only.',
  'cash.notes': 'Notes',
  'cash.active': 'Active',
  'cash.saved': 'Saved',
  'cash.checkHint': 'Compares the ФОП each fiscal payment went to (by its Enote money account) with the rotation of its shift. Branches are pooled: Enote payments carry no branch.',
  'cash.checked': 'Payments checked',
  'cash.byDay': 'By day',
  'cash.planned': 'Rotation',
  'cash.actual': 'Actual (payments)',
  'cash.mismatchedPayments': 'Payments not on the day’s register',
  'cash.noMismatches': 'All payments went to the rotation’s registers',
  'cash.noMismatchesHint': 'No mismatches in this period.',
  'cash.paidAt': 'Payment',
  'cash.actualFop': 'Actual ФОП',
  'cash.expected': 'Expected',
  'cash.amount': 'Amount',
  'cash.status': 'Status',
  'cash.nightHint': 'The doctor records a payment taken at night from the phone (or /night in the bot). In the morning the desk posts it in the fiscal register and Enote and marks it «Posted».',
  'cash.recordNight': 'Record a night payment',
  'cash.recordNightHint': 'Amount, method and who paid — as on the paper form.',
  'cash.record': 'Record',
  'cash.nightRecorded': 'Night payment recorded',
  'cash.noNight': 'No night payments',
  'cash.noNightHint': 'When you take a payment at night, record it here or with /night in the bot.',
  'cash.takenBy': 'Taken by: {name}',
  'cash.postedAs': 'Posted as payment #{number} ({by})',
  'cash.posted': 'Posted',
  'cash.suggested': 'Similar Enote payments:',
  'cash.cancelNight': 'Cancel entry',
  'cash.reason': 'Reason',
  'cash.method': 'Method',
  'cash.owner': 'Owner',
  'cash.pet': 'Pet',
  'cash.forWhat': 'For what',
  'cash.fromPaper': 'Copied from the paper form',
  'cash.month': 'Month',
  'cash.requestDiscount': 'Request a discount',
  'cash.noDiscounts': 'No discount requests',
  'cash.noDiscountsHint': 'A doctor or the desk creates a request: category, visit, reason. The amount follows the category rule.',
  'cash.category': 'Category',
  'cash.who': 'Client',
  'cash.staffFlag': 'Staff',
  'cash.visitN': 'Visit {n}',
  'cash.requestedBy': 'Requested by {name}',
  'cash.approve': 'Approve',
  'cash.reject': 'Reject',
  'cash.applied': 'Applied in Enote',
  'cash.withdraw': 'Withdraw',
  'cash.discountReport': 'Discounts of the month by category',
  'cash.requests': 'Requests',
  'cash.approvedN': 'Approved',
  'cash.total': 'Total',
  'cash.evidenceCheck': 'Check: {what}',
  'cash.staffRule': 'Staff discounts are approved by finance and flagged.',
  'cash.visitId': 'Enote visit (id)',
  'cash.visitIdHint': 'Client, pet and the full price are taken from the visit.',
  'cash.employee': 'Employee',
  'cash.basePrice': 'Full price, UAH',
  'cash.basePriceHint': 'Empty — the visit total.',
  'cash.percent': 'Percent',
  'cash.fixedAmount': 'Or a fixed amount, UAH',
  'cash.evidence': 'What was checked',
  'cash.evidenceHint': 'E.g. «veteran ID checked». Never write document numbers.',
  'cash.discountPreview': 'Discount: {sum}',
  'cash.discountSent': 'Request sent for approval',
  'cash.send': 'Send',
  'cash.limitsHint': 'Yearly turnover of every ФОП (payments by Enote money account, minus returns, bonuses excluded) against its single-tax limit, with a year-end forecast. Decisions on turnover distribution stay with the owner.',
  'cash.year': 'Year',
  'cash.limitsToConfirm': 'Group limits need confirmation (norm fop_income_limits)',
  'cash.unattributed': 'Payments without ФОП: {sum}',
  'cash.net': 'Turnover',
  'cash.limit': 'Limit',
  'cash.limitOwn': 'own',
  'cash.limitGroup': 'by group',
  'cash.limitNone': 'not set',
  'cash.share': 'Used',
  'cash.forecast': 'Year forecast',
  'cash.group': 'group {g}',
  'cash.noGroup': 'no tax group',
  'cash.setLimit': 'Limit',
  'cash.setLimitFor': 'Limit: {fop}',
  'cash.limitEmptyHint': 'Empty — the limit of the single-tax group.',
  'cash.payrollHint': 'Monthly checklist over the payroll file: staff pets’ debts and advances, unrecalculated receipts, staff discounts, debts closed from salary, loan repayments. Salaries are not stored in Bridge.',
  'cash.startPayroll': 'Start month-end control',
  'cash.payrollStarted': 'Month-end checklist created',
  'cash.noPayroll': 'No month-end controls yet',
  'cash.noPayrollHint': 'Choose a month and press «Start month-end control».',
  'cash.progress': 'Done',
  'cash.due': 'Due',
  'cash.payrollDone': 'Done',
  'cash.payrollOpen': 'In progress',
  'cash.overdue': 'Overdue',
  'cash.addLoan': 'New loan',
  'cash.noLoans': 'No loans',
  'cash.noLoansHint': 'Record a loan to an employee or another party: amount, currency, rate, due date and repayment plan.',
  'cash.counterparty': 'Counterparty',
  'cash.balance': 'Balance',
  'cash.loanIssued': 'Issued by the clinic',
  'cash.loanReceived': 'Received by the clinic',
  'cash.repaymentsN': 'Repayments: {n}',
  'cash.repay': 'Repayment',
  'cash.writeOff': 'Write off',
  'cash.loanN': 'Loan #{n}',
  'cash.direction': 'Direction',
  'cash.currency': 'Currency',
  'cash.rate': 'Rate to UAH',
  'cash.issuedOn': 'Issued',
  'cash.schedule': 'Repayment plan',
  'cash.repayLoan': 'Repayment of loan #{n}',
  'cash.balanceIs': 'Balance: {sum}',
  'cash.paidOn': 'Date',
}
